import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import * as serviceWorker from './serviceWorker'

import {
  labsAPI,
  gatoAPI,
  perfilAPI,
  analyticsUtils,
} from '@elgatoylacaja/utils'

analyticsUtils.INITIALIZE(process.env.REACT_APP_GOOGLE_GTAG_ID as string)

labsAPI.configure(
  process.env.REACT_APP_LABS_API_URL as string,
  process.env.REACT_APP_EXPERIMENT_SLUG as string
)
gatoAPI.configure(process.env.REACT_APP_GATO_API_URL as string)
perfilAPI.configure(process.env.REACT_APP_PERFIL_API_URL as string)

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
